import styled from 'styled-components';
import { spacing, containers } from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color('grey_light')};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.font.regular};
`;

const Container = styled.article.attrs({
  'data-test': 'news-article'
})`
  background: ${({ theme }) => theme.color('white')};
  width: 100%;
  max-width: ${containers.small};
  margin: ${spacing('l')} auto;
  padding: ${spacing('md')};

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: ${spacing('l')} ${spacing('xl')};
  }

  img {
    margin-bottom: ${spacing('l')};
  }

  [data-test="social-share"] {
    margin-bottom: ${spacing('md')};

    @media ${({ theme }) => theme.allBreakpoints('L')} {
      margin-bottom: ${spacing('l')};
    }

    img {
      margin: 0;
    }
  }
`;

const Header = styled.header`
  padding-top: ${spacing('l')};
  text-align: center;
  width: 100%;
  max-width: ${containers.small};
  margin: 0 auto;
`;

const Image = styled.div`
  width: 100%;
  margin: 0 auto;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    width: 130%;
    margin-left: -15%;
  }
`;

export {
  Wrapper, Container, Header, Image
};
